// @ts-strict-ignore
import { SubscriptionListUrlSortField } from "@dashboard/orders/urls";
import { SubscriptionRow } from "@dashboard/orders/views/OrderSubscriptionsList/OrderSubscriptionsList.utils";

export function getSubscriptionsRowsLength(
  rows?: SubscriptionRow[],
  loading?: boolean,
) {
  if (loading) {
    return 1;
  }

  if (rows?.length) {
    return rows.length;
  }

  return 0;
}

export function canBeSorted(sort: SubscriptionListUrlSortField) {
  switch (sort) {
    case SubscriptionListUrlSortField.order:
    case SubscriptionListUrlSortField.customer:
    case SubscriptionListUrlSortField.status:
    case SubscriptionListUrlSortField.nextPayment:
    case SubscriptionListUrlSortField.interval:
    case SubscriptionListUrlSortField.amount:
    case SubscriptionListUrlSortField.originalOrderDate:
      return true;
    default:
      return false;
  }
}
